module.exports = __webpack_public_path__ + "img/classification1.932fbbdb.png";